
import { elementsOverlap } from '~/mixins/elementsOverlap'

export default {
  mixins: [elementsOverlap],
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    modalClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      closeBtnIsOverlapping: false,
      modalWidth: this.$store.state?.app?.containerWidth,
    }
  },
  watch: {
    '$store.state.app.containerWidth'() {
      this.modalWidth = this.calculateModalWidth()
    },
    open: {
      handler(isOpen) {
        this.$nextTick(() => {
          // on modal open
          this.initCloseBtnColor()

          // lock body scroll
          if (isOpen) {
            document.body.style.overflow = 'hidden'

            this.$refs.modal.addEventListener('scroll', () =>
              this.onModalScroll()
            )
          } else {
            document.body.style.overflow = 'scroll'
          }
        })
      },
    },
    closeBtnIsOverlapping: {
      handler(isoverlapping) {
        // overlaps only occurs on mobile
        if (isoverlapping) {
          this.$refs.close.$el.style.color = '#3D3E46' // coolGrey 600
        } else {
          this.$refs.close.$el.style.color = '#fff' // white
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.modalWidth = this.calculateModalWidth()
    })
  },
  methods: {
    initCloseBtnColor() {
      if (!this.$refs?.close) return

      if (this.$matchMedia('lg')) {
        // set close button color for wider layout
        this.$refs.close.$el.style.color = '#ffffffb3'
      } else {
        // set close button color for smaller layout
        this.$refs.close.$el.style.color = '#fff'
      }
    },
    enter() {
      // chanage close button color on overlay hover
      // disable on mobile
      if (!this.$matchMedia('lg')) return

      if (this.$refs?.close) this.$refs.close.$el.style.color = '#fff'
    },
    leave() {
      // revert close button color on overlay leave
      // disable on mobile
      if (!this.$matchMedia('lg')) return

      if (this.$refs?.close) this.$refs.close.$el.style.color = '#ffffffb3'
    },
    onModalScroll() {
      // we want to check if modal scrolls over close button
      // in which case we want to change the color for visibility
      this.closeBtnIsOverlapping = this.elementsOverlap(
        this.$refs.modalBody,
        this.$refs.close.$el
      )
    },
    calculateModalWidth() {
      return !this.$matchMedia('sm')
        ? 'auto'
        : `${this.$store.state?.app?.containerWidth + 24 * 2}px`
    },
  },
}
